import { compose, branch, renderNothing, withHandlers } from 'recompose';
import { prop } from 'ramda';
import { connect } from 'react-redux';
import { getIsFetching, getMembership } from '../../validated/selectors';
import { closeChargeModal } from '../reducer/chargeModal/actions';
import { getChargeModal } from '../reducer/chargeModal/selectors';
import ChargeModal from '../components/ChargeModal';
import { getCurrentPayment } from '../reducer/currentPayment/selectors';
import { resetPayments } from '../actions';

const ChargeModalContainer = compose(
  connect(
    state => ({
      show: !getChargeModal(state),
      currentPayment: getCurrentPayment(state),
      disabled: getIsFetching(state),
      readerState: state.register.webReader.stage,
      cardPaymentOnly: !!getMembership(state),
    }),
    { closeChargeModal, resetPayments }
  ),
  withHandlers({
    closeChargeModal: props => () => {
      if (props.readerState !== null) {
        return null;
      }

      props.resetPayments();
      return props.closeChargeModal();
    },
  }),
  branch(
    prop('show'),
    renderNothing
  )
)(ChargeModal);

export default ChargeModalContainer;
